<template >
  <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
      <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">کاربران سیستم</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important">
                <v-card>
                    <v-card-title>
                     <v-layout row wrap>
                         <v-flex xs12 sm12 md9 lg9 xl9 style="padding-right:15px;padding-left:15px;">
                             <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchusers" append-icon="fas fa-search"></v-text-field>   
                         </v-flex>
                         <v-flex xs12 sm12 md3 lg3 xl3 style="padding-right:15px;padding-left:15px;">
                             <v-btn outlined color="#4CAF50" @click="userCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;کاربر جدید</v-btn>&nbsp;
                             <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>
                         </v-flex>
                     </v-layout>
                    </v-card-title>
                    <v-card-text>
                    <v-data-table items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingUser" :headers="userTableHeader" :search="searchusers" :items="userTableItems">
                        
                        <template v-slot:[`item.operation`]="{ item }">
                            <v-btn text icon small color="baseColor" @click="editUser(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                        </template>
                        <template v-slot:[`item.u_Status`]="{ item }">
                            <v-btn small text color="#D32F2F" @click="ActiveItem(item.u_Id)" dark v-if="item.u_Status == 2">غیر فعال</v-btn>
                            <v-btn small text color="#2E7D32" @click="DisableItem(item.u_Id)" dark v-else> فعال</v-btn>
                        </template>
                    </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
      </v-layout>
      <template>
          <v-dialog max-width="90%" persistent v-model="userCreationDialog">
              <v-card>
                  <v-card-title>
                      <v-toolbar dense flat>
                          <v-toolbar-title>
                              <span v-if="!inEditingMode">افرودن کاربر</span>
                              <span v-else style="color:orange">ویرایش کاربر</span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="red" @click="closeDialog">fa fa-times</v-icon>
                      </v-toolbar>
                  </v-card-title>
                  <v-card-text>
                        <v-stepper v-model="userStepperFormModel">
                            <v-stepper-header style="background-color:#262d47;color:orange">
                            <v-stepper-step dark color="orange" :complete="userStepperFormModel > 1" step="1">&nbsp;<span style="color:orange">مشخصات فردی</span> &nbsp;</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step color="orange"  step="3">&nbsp;مجوز ها &nbsp;</v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-form ref="uPersonalInfoFrom">
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 lg6 xl6 class="padding-20">
                                    <v-text-field :rules="uNameRule" color="#2a2d45"  v-model="uName" outlined dense hint="نام" persistent-hint placeholder="نام"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg6 xl6 class="padding-20">
                                    <v-text-field :rules="uFamilyRule" color="#2a2d45" v-model="uFamily" outlined dense hint="نام خانوادگی" persistent-hint placeholder="نام خانوادگی"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg6 xl6 class="padding-20">
                                    <v-text-field :rules="uPhoneRule" style="direction:ltr"  v-model="uPhone" outlined dense hint="تلفن" persistent-hint placeholder="تلفن" prefix="+98"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg6 xl6 class="padding-20">
                                    <v-text-field :rules="uEmailRule" v-model="uEmail" style="direction:ltr" outlined dense hint="پست الکترونیکی" persistent-hint placeholder="پست الکترونیکی"></v-text-field>
                                    </v-flex>
                                    <v-flex v-if="!inEditingMode" xs12 sm12 md12 lg6 xl6 class="padding-20">
                                    <v-text-field :rules="uPasswordRule" v-model="uPassword" outlined dense hint="رمز عبور" persistent-hint placeholder="رمز عبور"></v-text-field>
                                    </v-flex>
                                    <v-flex v-if="!inEditingMode" xs12 sm12 md12 lg6 xl6 class="padding-20">
                                    <v-text-field :rules="UConfirmPasswordRule" v-model="UConfirmPassword" outlined dense hint="تکرار رمز عبور" persistent-hint placeholder="تکرار رمز عبور"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg12 xl12 class="padding-20">
                                    <div style="width:100%;text-align:left">
                                        <v-btn @click="JumpStep(2)" dark outlined color="#262d47">بعدی&nbsp;<v-icon small style="padding-right:5px;">fa fa-arrow-left</v-icon></v-btn>
                                    </div>
                                    </v-flex>
                                </v-layout>
                                </v-form>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-form ref="uMainInfoFrom">
                                <v-layout row wrap>
                                    
                                    <v-flex xs12 sm12 md12 lg12 xl12 class="padding-20">
                                    <v-treeview
                                        selectable
                                        v-model="SelectedPermissions"
                                        selected-color="red"
                                        item-key="meta.id"
                                        item-text="meta.title"
                                        :items="Permissions"
                                    ></v-treeview>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 lg12 xl12 class="padding-20">
                                    <div style="width:100%;text-align:left">
                                        <v-btn dark @click="userStepperFormModel--" color="primary">قبلی</v-btn>&nbsp;&nbsp;
                                        <v-btn dark @click="registerUser" color="baseColor">ذخیره</v-btn>
                                        
                                    </div>
                                    </v-flex>
                                </v-layout>
                                </v-form>
                            </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                  </v-card-text>
              </v-card>
          </v-dialog>
      </template>
  </div>
</template>
<script>
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
const axios = require('axios');
export default {
    name:"sysuser",
    data:()=>({
        searchusers:"",
        isLoadingUser:false,
        userStepperFormModel:1,
        uName:"",
        uFamily:"",
        userAvatar:"",
        phoneMask:"",
        uPhone:"",
        uEmail:"",
        uPassword:"",
        UConfirmPassword:"",
        SelectedPermissions:[],
        uNameRule:[],
        uFamilyRule:[],
        uPhoneRule:[],
        uEmailRule:[],
        Permissions:[],
        uPasswordRule:[],
        UConfirmPasswordRule:[],
        userTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"نام و نام خانوادگی",value:"surename",sortable:true,align:"right"},
            {text:"تلفن",value:"u_Phone",sortable:true,align:"right"},
            {text:"پست الکترونیکی",value:"u_Email",sortable:true,align:"right"},
            {text:"وضعیت",value:"u_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        userTableItems:
        [
        ],
        userCreationDialog:false,
        inEditingMode : false,
        EditItem:{}
    }),
    async created(){
        let vm = this;
        vm.$router.options.routes.forEach(route => {
            if(route.name != "login")
            {
                vm.Permissions.push(route);
            }
        });
        await vm.loadUsers();
        console.warn(vm.Permissions);
    },
    methods:{
        closeDialog()
        {
            let vm = this;
            vm.$refs.uPersonalInfoFrom.reset();
            vm.SelectedPermissions = [];
            vm.inEditingMode = false;
            vm.userCreationDialog = false;
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.U_Id = id;
            await axios.post(ApiUrl.SysUserSuspend,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadUsers();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.U_Id = id;
            await axios.post(ApiUrl.SysUserActive,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadUsers();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        editUser(user)
        {
            let vm = this;
            vm.SelectedPermissions = user.permissions;
            vm.uName = user.u_Name;
            vm.uFamily = user.u_Family;
            vm.uEmail = user.u_Email;
            vm.uPhone = user.u_Phone;
            vm.inEditingMode = true;
            vm.EditItem = user;
            vm.userCreationDialog = true;
        },
        JumpStep(step)
        {
            let vm = this;
            vm.userStepperFormModel = step;
        },
        async registerUser()
        {
            let vm = this;
            let url = ApiUrl.SysUserAdd;
            var Model = {};
            console.warn(vm.SelectedPermissions);
            if(vm.inEditingMode)
            {
                url = ApiUrl.SysUserUpdate;
                Model.U_Id = vm.EditItem.u_Id;
            }
            else
            {
                Model.U_Password = vm.uPassword;
            }
            
            Model.U_Name = vm.uName;
            Model.U_Family = vm.uFamily;
            Model.U_Email = vm.uEmail;
            Model.U_Phone = vm.uPhone;
            Model.U_Role = 1;
            Model.Permissions = vm.SelectedPermissions;
            await axios.post(url,Model)
            .then(async function(res){
                var data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.closeDialog();
                    await vm.loadUsers();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch(function(err){
                console.error(err);
            });
        },
        async loadUsers()
        {
            let vm = this;
            var url=ApiUrl.SysUserLoad+'/1';
            
            await axios.post(url)
                .then(function (res) {
                    console.log(res);
                    if(res.data.status)
                    {
                       vm.userTableItems = res.data.data;
                       console.warn(res.data.data);
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        }
    }
}
</script>
<style scoped>
.padding-20
{
    padding:20px;
}
</style>
<style>
.v-stepper__step--inactive .v-stepper__label
{
    color: rgba(255, 255, 255, 0.13) !important;
}
.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background: rgb(57, 64, 88) !important;
}
</style>